(function () {
  // Evita inicializar duas vezes caso o script seja incluído por mais de uma seção na mesma página
  if (window.__videoAutoplayFixInit) return;
  window.__videoAutoplayFixInit = true;

  function isInViewport(video) {
    var rect = video.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
  }

  function setup(video) {
    if (video.dataset.autoplayFixApplied) return;
    video.dataset.autoplayFixApplied = 'true';

    video.muted = true;

    function tryPlay() {
      // Só tenta tocar se realmente estiver pausado e visível na tela
      if (!video.paused && !video.ended) return;
      if (!isInViewport(video)) return;
      var p = video.play();
      if (p !== undefined) {
        p.catch(function () {
          // Autoplay bloqueado (ex: modo economia de dados). Vai tentar de novo
          // no próximo gesto do usuário (touchstart) ou no próximo scroll.
        });
      }
    }

    // Toca quando o vídeo entra na tela, pausa quando sai
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            tryPlay();
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: 0.25 });
      observer.observe(video);
    } else {
      tryPlay();
    }

    // CHAVE DA CORREÇÃO:
    // O tema Shopify (Sense/Dawn) pausa TODOS os vídeos da página sempre que você
    // troca de variante, abre a galeria, abre o carrinho, etc (função pauseAllMedia).
    // Sem isso, o vídeo ficava travado no frame pausado até a página recarregar.
    video.addEventListener('pause', function () {
      setTimeout(function () {
        if (isInViewport(video)) tryPlay();
      }, 150);
    });

    // Garantias extras para quando o vídeo termina de carregar os metadados
    video.addEventListener('loadedmetadata', tryPlay);
    video.addEventListener('canplay', tryPlay);

    // Fallback: em navegadores que só liberam autoplay após um gesto real do usuário
    // (ex: Data Saver ativo no Samsung Internet), tenta tocar uma vez no primeiro toque.
    function gestureFallback() {
      tryPlay();
      document.removeEventListener('touchstart', gestureFallback);
      document.removeEventListener('click', gestureFallback);
    }
    document.addEventListener('touchstart', gestureFallback, { passive: true, once: true });
    document.addEventListener('click', gestureFallback, { once: true });
  }

  function init() {
    document.querySelectorAll('video[data-video-autoplay]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reaplica quando o Shopify recarrega uma seção (editor de temas, sections rendering)
  document.addEventListener('shopify:section:load', init);
})();